import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      component: () => import('@/modules/home/')
    }
  ]
})

const routes = [
  {
    path: '/plans/',
    load: () => import('@/modules/plans/route.js')
  },
  {
    path: '/timekeeping/',
    load: () => import('@/modules/timekeeping/route.js')
  },
  {
    path: '/reports/',
    load: () => import('@/modules/reports/route.js')
  },
  {
    path: '/harvest/',
    load: () => import('@/modules/harvest/route.js')
  },
  {
    path: '/categories/',
    load: () => import('@/modules/categories/route.js')
  },
  {
    path: '/statistics',
    load: () => import('@/modules/statistics/route.js')
  },
  {
    path: '/manage-order',
    load: () => import('@/modules/manage-order/route.js')
  }
]
const dynamicRoute = {
  path: '*',
  beforeEnter: (to, from, next) => {
    let route
    const path = to.path + '/'
    routes.forEach(function (routeItem) {
      if (path.startsWith(routeItem.path)) route = routeItem
    })
    if (route && !route.loaded) {
      route.load().then(function (routeConfig) {
        router.addRoutes(routeConfig.default)
        route.loaded = true
        next({ path: to.fullPath, replace: true })
      })
    } else {
      next(false)
    }
  }
}

router.addRoutes([dynamicRoute])

export default router
